// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as ErrorBoundary$OrcaPaymentPage from "./ErrorBoundary.bs.js";

function ReusableReactSuspense(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  return React.createElement(ErrorBoundary$OrcaPaymentPage.make, {
              children: React.createElement(React.Suspense, {
                    children: Caml_option.some(props.children),
                    fallback: Caml_option.some(props.loaderComponent)
                  }),
              level: "PaymentMethod",
              componentName: props.componentName,
              publishableKey: match.publishableKey
            });
}

var make = ReusableReactSuspense;

export {
  make ,
}
/* react Not a pure module */
